import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryWastSiteStand, siteStandardTotal } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      chart: 'chart'
    };
  },
  mounted: function mounted() {},
  methods: {
    initBarChart: function initBarChart(data) {
      var titleArr = [],
          seriesArr = [];
      var colors = [["#389af4", "#dfeaff"], ["#ff8c37", "#ffdcc3"], ["#ffc257", "#ffedcc"]];
      data.forEach(function (item, index) {
        titleArr.push({
          text: item.name,
          left: index * 20 + 30 + "%",
          top: "55%",
          textAlign: "center",
          textStyle: {
            fontWeight: "normal",
            fontSize: "16",
            color: colors[index][0],
            textAlign: "center"
          }
        });
        seriesArr.push({
          name: item.name,
          type: "pie",
          clockWise: false,
          radius: [60, 70],
          itemStyle: {
            normal: {
              color: colors[index][0],
              shadowColor: colors[index][0],
              shadowBlur: 0,
              label: {
                show: false
              },
              labelLine: {
                show: false
              }
            }
          },
          hoverAnimation: false,
          center: [index * 20 + 30 + "%", "50%"],
          data: [{
            value: item.value,
            label: {
              normal: {
                formatter: function formatter(params) {
                  return params.value + "%";
                },
                position: "center",
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold",
                  color: colors[index][0]
                }
              }
            }
          }, {
            value: 100 - item.value,
            name: "invisible",
            itemStyle: {
              normal: {
                color: colors[index][1]
              },
              emphasis: {
                color: colors[index][1]
              }
            }
          }]
        });
      });
      var option = {
        title: titleArr,
        series: seriesArr
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};